export default __webpack_public_path__ + "static/media/invalid_person.0d106d7a.svg";